import React from 'react';
import { WidgetPanel } from '../WidgetPanel/WidgetPanel';
import { WidgetFilterOption } from '../../../Models';
import { FilterSelector } from '../FilterSelector/FilterSelector';

export interface WidgetFiltersPanelProps {
  options: WidgetFilterOption[];
  isOpen: boolean;
  checked: string[];
  onChange: (checked: string[]) => void;
  onToggle: () => void;
}

export const WidgetFiltersPanel = ({
  options,
  checked,
  isOpen,
  onChange,
  onToggle
}: WidgetFiltersPanelProps): React.ReactElement<WidgetFiltersPanelProps> => {
  return (
    <WidgetPanel isOpen={isOpen} onToggle={onToggle}>
      <FilterSelector options={options} value={checked} onChange={onChange} />
    </WidgetPanel>
  );
};
